import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-t-example',
  templateUrl: './t-example.component.html',
  styleUrls: ['./t-example.component.css']
})
export class TExampleComponent extends GeneralTeacherComponent {

  level: number;
  standardPage:string = "none";

  constructor(protected topicService: TopicService, protected activatedRoute: ActivatedRoute) {
    super(topicService, activatedRoute);
    this.type = "example";
    this.title = this.get("example");
  }

  setInformationWithConfiguration(){
    super.setInformationWithConfiguration();
    this.level = this.configuration.level;
    this.standardPage = this.configuration.typespecifics.standardPage;
  }

  reset(){
    super.reset();
    this.standardPage = "none";
  }

  generateDefinition(){
    let definition: any = {};
    definition.typespecifics = {};
    definition.title = this.title;
    definition.description = this.description;
    definition.type = this.type;
    definition.image = "./assets/images/example_white.png";
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.key = "searchAndOrder%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.key = definition.key.concat(this.title);
    definition.level = this.standardPage=='none'?this.level:3;
    definition.typespecifics.standardPage = this.standardPage;
    return definition;
  }
}
